import { render, staticRenderFns } from "./RecordTranslation.vue?vue&type=template&id=86bceb6e&scoped=true"
import script from "./RecordTranslation.vue?vue&type=script&lang=js"
export * from "./RecordTranslation.vue?vue&type=script&lang=js"
import style0 from "./RecordTranslation.vue?vue&type=style&index=0&id=86bceb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bceb6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAlert,VBtn,VCheckbox})
